import gql from 'graphql-tag'

export const GET_CONTACTS = gql`
  query Contacts($filter: GetContactsFilter) {
    contacts(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      contacts {
        data {
          contactId
          email
          label
          phoneNumber
          user {
            fullname
          }
          userId
        }
        pagination {
          page
          show
          total
        }
      }
    }
  }
`

export const GET_CONTACT = gql`
  query Contact($filter: GetContactFilter!) {
    contact(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      contact {
        contactId
        email
        label
        phoneNumber
        user {
          fullname
        }
        userId
      }
    }
  }
`

export const CREATE_CONTACT = gql`
  mutation CreateContact($input: CreateContactInput!) {
    createContact(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      createContact {
        contactId
        email
        label
        phoneNumber
        user {
          fullname
          userId
        }
        userId
      }
    }
  }
`

export const UPDATE_CONTACT = gql`
  mutation UpdateContact($input: UpdateContactInput!) {
    updateContact(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      updateContact {
        contactId
        email
        label
        phoneNumber
        user {
          fullname
          userId
        }
        userId
      }
    }
  }
`

export const DELETE_CONTACT = gql`
  mutation DeleteContact($input: DeleteContactInput!) {
    deleteContact(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      deleteContact {
        contactId
        email
        label
        phoneNumber
        user {
          fullname
        }
        userId
      }
    }
  }
`
